import React from "react";
import { useEffect, useState, useMemo, useCallback } from "react";
import {
  Button,
  Box,
  Typography,
  CircularProgress,
  TextField,
  styled,
  MenuItem,
  debounce,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchGoalsData } from "../../../../action/userOwnGoals";
import { toast } from "react-toastify";
import { isArray } from "jquery";
import GoalVideoComponent from "./GoalVideoComponent";
import VideoSkeleton from "../../Leaderboard/VideoSkeleton";
import moment from "moment";
import { useSkipFirstRender } from "../../../../hooks/useSkipFirstRender";
import CategoryComponent from "../../CategoryComponent/Index";
import { CustomTextarea } from "../../formComponents/CustomTextArea";
import { useDebounce } from "../../../../hooks/useCustomDebounce";
import { deleteGoal } from "../../../../api/deleteGoal";

const Index = ({ filterState }) => {
  const token = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.user);
  const myGoalsData = useSelector((state) => state.myGoals);
  const myTournamentsData = useSelector((state) => state.myTournaments);
  const [myGoals, setMyGoals] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const globalSearchData = useSelector((state) => state.globalSearch);
  const [yearMonth, setyearMonth] = useState("default");
  const goalCategories = useSelector((state) => state.goalCategories);
  const features = useSelector((state) => state.features);
  const [subFilter, setSubFilter] = useState("");
  const [childFilter, setChildFilter] = useState("");

  const fetchSearchResult = useCallback(
    (token, filter, user_id, key, subFilter, childFilter) => {
      dispatch(
        fetchGoalsData(
          token,
          filter,
          user_id,
          key,
          true,
          {},
          { subFilter, childFilter },
          // yearData.yearData
        ),
      );
    },
    [],
  );

  const debouncedSearch = useDebounce(fetchSearchResult, 500);


  useEffect(() => {
    const year = yearMonth?.split("-")?.pop();
    const month = yearMonth?.split("-")[0];
    const yearData = { year, month };
    if (userData.data?.id && token) {
      // if (myGoalsData.data?.data[0]?.goals.length > 0) {
      // if (Array.isArray(myGoals) && myGoals.length > 0) {
      debouncedSearch(
        token,
        filter,
        userData.data.id,
        globalSearchData.search,
        subFilter,
        childFilter,
        // globalSearchData.api,
        // myGoalsData.data?.data[0]?.goals,
        // filter,
        // filterState,
        // { id: userData.data.id, token, yearData }
      );
      // }
    }

  }, [globalSearchData]);

  useEffect(() => {
    if (token && userData?.data?.id) {
      dispatch(fetchGoalsData(token, filter, userData.data.id, "", true));
    }
  }, []);

  useSkipFirstRender(() => {
    const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
    const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];
    if (token && userData?.data?.id) {
      setLoading(true);

      dispatch(
        fetchGoalsData(token, filter, userData.data.id, "", true, {
          year,
          month,
        }),
      );
    }
  }, [filter]);

  useSkipFirstRender(() => {
    const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
    const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];

    if (token && userData?.data?.id && subFilter) {
      setLoading(true);

      dispatch(
        fetchGoalsData(
          token,
          filter,
          userData.data.id,
          "",
          true,
          {
            year,
            month,
          },
          { subFilter, childFilter },
        ),
      );
    }
  }, [subFilter]);

  useSkipFirstRender(() => {
    const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
    const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];

    if (token && userData?.data?.id && childFilter) {
      setLoading(true);

      dispatch(
        fetchGoalsData(
          token,
          filter,
          userData.data.id,
          "",
          true,
          {
            year,
            month,
          },
          { subFilter, childFilter },
        ),
      );
    }
  }, [childFilter]);

  useSkipFirstRender(() => {
    const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
    const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];
    if (token && userData?.data?.id) {
      setLoading(true);

      dispatch(
        fetchGoalsData(
          token,
          filter,
          userData.data.id,
          "",
          true,
          {
            year,
            month,
          },
          { subFilter, childFilter },
        ),
      );
    }
  }, [yearMonth]);

  /// for my goals
  useEffect(() => {
    if (globalSearchData.search) {
      if (myGoalsData.searchData?.success) {
        if (myGoalsData.searchData?.data[0]?.goals?.length > 0) {
          setMyGoals(myGoalsData.searchData?.data[0]?.goals);
          setLoading(false);
        } else {
          setMyGoals("No Data Found");
          setLoading(false);
        }
      }
    } else {
      if (myGoalsData.data?.success) {
        if (myGoalsData.data?.data[0]?.goals?.length > 0) {
          setMyGoals(myGoalsData.data?.data[0]?.goals);
          setLoading(false);
        } else {
          setMyGoals("No Data Found");
          setLoading(false);
        }
      }
    }

    if (myGoalsData?.error) {
      toast.error("Error! Please try again.");
      setMyGoals("Please Try again");
      setLoading(false);
    }

    setLoading(myGoalsData.loading);
  }, [myGoalsData]);

  const deleteHandlerGoals = useCallback(
    async (data) => {
      const year = yearMonth == "default" ? "" : yearMonth?.split("-")?.pop();
      const month = yearMonth == "default" ? "" : yearMonth?.split("-")[0];
      const resData = await deleteGoal(data.id, token);
      if (resData?.success) {
        toast.success(resData?.message);
        const date = new Date();
        dispatch(
          fetchGoalsData(
            token,
            filter,
            userData.data.id,
            globalSearchData.search,
            true,
            {
              year,
              month,
            },
            { subFilter, childFilter },
          ),
        );

        // setDeleting(false);
      } else {
        // setDeleting(false);
        toast.error(resData);
      }
    },
    [yearMonth, childFilter, subFilter, globalSearchData],
  );

  return (
    <>
      {goalCategories.loading ? (
        <CircularProgress />
      ) : Array.isArray(goalCategories.data.data) ? (
        <CategoryComponent
          categories={goalCategories.data.data}
          filter={filter}
          setFilter={setFilter}
          subFilter={subFilter}
          setSubFilter={setSubFilter}
          childFilter={childFilter}
          setChildFilter={setChildFilter}
          page={"MyAccount"}
        />
      ) : (
        "No category data found"
      )}

      <Box
        className="Category-filter-wrapper"
        sx={{ justifyContent: "space-between" }}
      >
        <CustomTextarea
          select
          variant="outlined"
          name="previous_months"
          value={yearMonth}
          onChange={(e) => {
            if (e.target.value == "default") {
              setyearMonth("default");
              return;
            }

            setyearMonth(e.target.value);
          }}
          sx={{
            maxWidth: "200px",
            border: "1px solid #414466",
            padding: "7px",
            borderRadius: "8px",
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom", // Anchor point on the Select component
              horizontal: "right",
            },
            transformOrigin: {
              vertical: "bottom", // Attachment point on the Menu component
              horizontal: "right",
            },
          }}
        >
          <MenuItem value="default">Select Year</MenuItem>
          {Array.from({ length: 24 }).map((_, i) => (
            <MenuItem value={moment().subtract(i, "months").format("M-YYYY")}>
              {`${moment().subtract(i, "months").format("MMM YYYY")}`}
            </MenuItem>
          ))}
        </CustomTextarea>
      </Box>

      <Box className="leaderboard-data-wrapper">
        {loading ? (
          Array.from({ length: 10 }).map((ele) => <VideoSkeleton />)
        ) : isArray(myGoals) && myGoals.length > 0 ? (
          myGoals.map((ele, index) => {
            return (
              <>
                <GoalVideoComponent
                  key={index}
                  data={ele}
                  filterState={filterState}
                  setData={setMyGoals}
                  deleteGoalFunc={deleteHandlerGoals}
                />
              </>
            );
          })
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: "1",
            }}
            className="error-state"
          >
            <Typography component="p">{"NO Goals Found"}</Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

export default Index;
